import type { EscoposFornecedorStepProps } from "./types-escopos-fornecedor-step";
import { useEscoposFornecedorStep } from "./use-escopos-fornecedor-step";
import { EscoposFornecedorStepView } from "./view-escopos-fornecedor-step";

export function EscoposFornecedorStep(props: EscoposFornecedorStepProps) {
  const vm = useEscoposFornecedorStep(props);

  return <EscoposFornecedorStepView {...vm} />;
}

export type * from "./types-escopos-fornecedor-step";
